export const phasesConfigValues = {
  SEND_ON_START: 'SEND_ON_START',
  SEND_ON_FINISH: 'SEND_START_AND_FINISH',
  SEND_ON_APP_LOADED: 'SEND_ON_START',
  SEND_START_AND_FINISH: 'SEND_START_AND_FINISH',
};
